export { default as ContentWrapper } from "./ContentWrapper/ContentWrapper";
export type { IContentWrapper } from "./ContentWrapper/ContentWrapper";
